/**
 * RosterTemplateSection — one container for the roster template, two ways to edit it.
 *
 * Download/upload (TemplateManager) and the in-browser grid (TemplateGridEditor)
 * write the same underlying records, so they used to be two separate, confusing
 * containers doing the same job through different doors. Here they share one:
 * apply an upload and the grid below refreshes to show it; save a grid edit and
 * the snapshot list above picks it up. Whichever door an admin walks in, a
 * download afterwards reflects whatever was saved most recently through either.
 */

import { useState } from "react";
import { TemplateManager } from "@/components/TemplateManager";
import { TemplateGridEditor } from "@/components/admin/TemplateGridEditor";

export function RosterTemplateSection() {
  // Bumped by TemplateManager after an apply/rollback/reset, so the grid reloads
  // what just changed instead of showing what it loaded on mount.
  const [reloadSignal, setReloadSignal] = useState(0);
  // Bumped by the grid after "Save grid", so TemplateManager's snapshot list
  // (a rollback point exists either way) picks it up without a manual refresh.
  const [refreshSignal, setRefreshSignal] = useState(0);

  return (
    <>
      <div
        style={{
          display: "flex", gap: 8, alignItems: "flex-start",
          background: "#EFF6FF", border: "1px solid #BFDBFE", borderRadius: 8,
          padding: "9px 11px", marginTop: 12, marginBottom: 16, fontSize: 12,
          color: "#1E3A5F", lineHeight: 1.6,
        }}
      >
        <span aria-hidden>ℹ️</span>
        <div>Applies to roster generated from now onwards, no change to rosters previously generated.</div>
      </div>

      <TemplateManager bare refreshSignal={refreshSignal} onChanged={() => setReloadSignal((n) => n + 1)} />

      <div style={{ borderTop: "1px dashed #e5e7eb", margin: "18px 0 14px" }} />

      <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 2 }}>
        Edit directly
      </div>
      <TemplateGridEditor reloadSignal={reloadSignal} onSaved={() => setRefreshSignal((n) => n + 1)} />
    </>
  );
}
